import "./projects.scss";
import { useState, useEffect }  from 'react';
import projectsData from '../../content.json';
import ModalPop from "./ModalPop";

const myFunction = (target) => {
    target.classList.add("d-none");
}
const ProjectCard = ({data, getButtonData}) => {
    const buttons = data['buttons'] === undefined ? [] : data['buttons'];
    const ButtonsHtml = buttons.map((data,i) => {
        return (
            <li className="list-group-item" key={i}>
                <a className="btn btn-default" href={data.url} target="_blank" rel="noreferrer">
                    {data.name}
                </a>
            </li>
        )
    });
    const badges = data['badges'] === undefined ? [] : data['badges'];
    const BadgesHtml = badges.map((data,i) => {
        return (
            <span className={`badge rounded-pill mx-1 ${data.color}`} key={i}>{data.name}</span>
        )
    });
    

    return(
        <div className="col-sm-6 col-md-4 card-container">
            <div className={`card card-${data.projectId}`} >
                { data.frontImage !== undefined &&
                    // <img className="card-img-top" src={`/images/${data.frontImage}`} alt="2nd project" onError={(e)=>{e.target.onerror = null; e.target.src="/images/image7/p"}}/>
                    <img className="card-img-top p-1" src={`/images/${data.frontImage}`} alt="2nd project" onError={(e) => myFunction(e.target)}/>
                }
                <div className="card-body">
                    <h4 className="card-title">{data.title}</h4>
                    <p className="card-text">{data.desc}</p>
                </div>
                <div className="badges-container text-right">
                    {BadgesHtml}
                </div>
                <ul className="list-group list-group-flush p-1">
                    { (data.images !== undefined && data.images.length !== 0) &&
                        <li className="list-group-item">
                            <button className="btn btn-default" title={data.title} onClick={() => getButtonData(data,'projects')}>
                            Quick View
                            </button>
                        </li>
                    }
                    {ButtonsHtml}
                </ul>
            </div>
        </div>
    )
}

const Projects = () => {
    const projectsJson = projectsData.projects;
    const [type, setType] = useState();
    const [modalData, setModalData] = useState([]);
    const [show, setShow] = useState(false);
    const [projectsHtml, setProjectsHtml] = useState();

    const getButtonData = (data,type) =>{
        setShow(true);
        setType(type);
        setModalData(data);
    }
    useEffect(() => {
        setProjectsHtml(projectsJson.map((data,i) => {
                return ( <ProjectCard data={data} getButtonData={getButtonData} key={`project-card-${i}`}/> )
            })
        )
    }, [projectsJson])

    return (
        <div className="projects sections-page sections-page-3" id="projects">
            <div className="container projects-landing-container">
                <div className="row">
                    <div className="col-12 d-sm-none sm-title">
                        <p>Projects</p>
                    </div>
                    {projectsHtml}
                </div>
            </div>
            {modalData && <ModalPop show={show} setShow={setShow} type={type} modalData={modalData}/>}
            
            <div className="parallax-background"></div>  
        </div>
    );
};

export default Projects;
